import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { EventWebhookService, EventSubscription } from '../../core/services/core.event-webhook.service';

@Component({
    selector: 'event-subscription-list',
    template: require('./event-subscription-list.component.html'),
})
export class EventSubscriptionListComponent implements OnInit, OnChanges {
    @Input() projectId: number | null = null;
    @Output() edit = new EventEmitter<number>();
    @Output() create = new EventEmitter<void>();

    subscriptions: EventSubscription[] = [];
    loading = false;
    error: string | null = null;
    confirmDeleteId: number | null = null;

    constructor(private service: EventWebhookService) {}

    ngOnInit() {
        this.load();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.projectId && !changes.projectId.firstChange) {
            this.load();
        }
    }

    load() {
        this.loading = true;
        this.error = null;
        const filters: any = {};
        if (this.projectId === null) {
            filters.project_id = 'null';
        } else if (this.projectId !== undefined) {
            filters.project_id = this.projectId;
        }
        this.service.listSubscriptions(filters)
            .then(subs => {
                this.subscriptions = (subs && subs.items) ? subs.items : [];
                this.loading = false;
            })
            .catch(err => {
                this.error = (err && err.error && err.error.message) || 'Failed to load subscriptions';
                this.loading = false;
            });
    }

    onEdit(id: number) {
        this.edit.emit(id);
    }

    onCreate() {
        this.create.emit();
    }

    requestDelete(id: number) {
        this.confirmDeleteId = id;
    }

    cancelDelete() {
        this.confirmDeleteId = null;
    }

    confirmDelete() {
        if (this.confirmDeleteId === null) { return; }
        const id = this.confirmDeleteId;
        this.confirmDeleteId = null;
        this.service.deleteSubscription(id)
            .then(() => this.load())
            .catch(err => {
                this.error = (err && err.error && err.error.message) || 'Delete failed';
            });
    }

    statusClass(status: string): string {
        if (status === 'success')                     { return 'label-success'; }
        if (status === 'failed' || status === 'dead') { return 'label-danger'; }
        if (status === 'pending' || status === 'in_flight') { return 'label-warning'; }
        return 'label-default';
    }
}
